import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as _ from 'lodash-es';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../environments/environment';
import { Environment } from '../../environments/environment.model';

@Injectable({
    providedIn: 'root'
})
export class EnvironmentResolver {
    private static readonly envConfigJsonPath = './assets/env-config.json';

    private environment: Environment | undefined;

    constructor(private readonly httpClient: HttpClient) {}

    /**
     * Sets environment based on provided env-config.json file.
     */
    async setEnvironment(): Promise<void> {
        if (this.environment) {
            throw new Error('Environment already set!');
        }

        try {
            const envConfigJson = await firstValueFrom(this.httpClient.get<Partial<Environment>>(EnvironmentResolver.envConfigJsonPath));
            // Override environment with envConfigJson
            this.environment = _.merge({}, environment, envConfigJson);
        } catch (e) {
            // eslint-disable-next-line
            console.warn('External configuration not found or invalid.', e);
            this.environment = environment;
        }
    }

    /**
     * Return environment based on environments/environment.*.json and assets/env-config.json.
     */
    getEnvironment(): Environment {
        if (!this.environment) {
            throw new Error('Environment not set!');
        }

        return this.environment;
    }
}
